import React from 'react';
import styled from 'styled-components';
import { __UNSAFE_SPACE_TO_DIMSUM } from '@elliemae/ds-system';
import PropTypes from 'prop-types';

var ActionItemNode = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1ysc0gb-0"
})(["padding-right:", ";font-weight:", ";overflow:hidden;align-items:center;display:flex;&:last-child{padding-right:0;}"], function (props) {
  return __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.xs);
}, function (props) {
  return props.theme.fontWeights[2];
});

function ActionItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ActionItemNode, null, children);
}

ActionItem.propTypes = {
  children: PropTypes.node.isRequired
};

export default ActionItem;
//# sourceMappingURL=ActionItem.js.map
